"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var APISettingResource = /** @class */ (function (_super) {
    tslib_1.__extends(APISettingResource, _super);
    function APISettingResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APISettingResource.endpoint = '/settings';
    APISettingResource.MODEL_NAME = 'appsetting';
    return APISettingResource;
}(base_1.default));
exports.default = APISettingResource;
//# sourceMappingURL=settings.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/settings.js
// module id = 6MVp
// module chunks = 0